/* global gcoScriptParams */
;(function ($, window) {
  'use strict'

  // setup a shared namespace, if needed
  window.GCO = window.GCO || {}

  window.GCO.filterPosts = (function () {
    function fetchPosts (e) {
      e.preventDefault()
      const $container = $('.container--cards .row')
      const category = $('.filter__options [name="category"]:checked').val()
      const params = {
        action: 'fetch_posts',
        // page: 0, // parseInt(gcoScriptParams.currentPage, 10) + 1,
        section: gcoScriptParams.section,
        category: category
      }
      $.ajax({
        url: gcoScriptParams.ajaxurl, // AJAX handler
        data: params,
        beforeSend: function (xhr) {
          $(document).trigger('posts-loading')
        },
        complete: function () {
          $(document).trigger('posts-loaded')
        },
        success: function (data) {
          if (data) {
            $container.empty().append(data)
            // gcoScriptParams.currentPage++

            // if (gcoScriptParams.currentPage >= gcoScriptParams.maxPage) {
            //   $(document).trigger('no-more-posts')
            // }
          } else {
            $(document).trigger('no-more-posts')
          }
        }
      })
    }

    function init () {
      const $btn = $('.btn--filter-posts')
      if ($btn) {
        $(document).on('posts-loading', () => $btn.text('Updating ...'))
        $(document).on('posts-loaded', () => $btn.text('Update'))
        // $(document).on('no-more-posts', () => $btn.text('No More Articles').attr('disabled', true))
        $btn.on('click', fetchPosts)
      }
    }

    return {
      init: init
    }
  }())

  $(document).ready(GCO.filterPosts.init)
}(jQuery, window))
